export default function EditIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M11.3334 2.00004C11.5086 1.82494 11.7164 1.68605 11.9451 1.59129C12.1738 1.49653 12.4188 1.44775 12.6667 1.44775C12.9146 1.44775 13.1596 1.49653 13.3883 1.59129C13.617 1.68605 13.8248 1.82494 14 2.00004C14.1751 2.17513 14.314 2.38297 14.4088 2.61165C14.5036 2.84032 14.5523 3.08534 14.5523 3.33337C14.5523 3.58141 14.5036 3.82643 14.4088 4.0551C14.314 4.28378 14.1751 4.49161 14 4.66671L5.00004 13.6667L1.33337 14.6667L2.33337 11L11.3334 2.00004Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

